import './HomeBirds.css';

/*
  Sparse flock, calm tempo. Birds start mid-distance (not in the foreground),
  drift toward the ridgeline vanishing point, shrink into haze, then loop.
  x/y are % of the mural stage; scale 1 = nearest in this flock.
*/
const BIRDS = [
  { id: 1, x0: 18, y0: 48, xv: 54, yv: 32, size: 28, duration: 42, delay: 0, flap: 0.72 },
  { id: 2, x0: 78, y0: 44, xv: 60, yv: 30, size: 22, duration: 48, delay: -16, flap: 0.8 },
  { id: 3, x0: 42, y0: 52, xv: 57, yv: 34, size: 24, duration: 52, delay: -28, flap: 0.76 },
  { id: 4, x0: 62, y0: 46, xv: 59, yv: 31, size: 20, duration: 46, delay: -8, flap: 0.78 },
  { id: 5, x0: 30, y0: 50, xv: 56, yv: 33, size: 26, duration: 50, delay: -22, flap: 0.7 },
];

/* Gull seen from behind — swept wings, no visible head. */
const BirdGlyph = () => (
  <svg
    className="home__bird-glyph"
    viewBox="0 0 24 10"
    aria-hidden="true"
    focusable="false"
  >
    <path
      className="home__bird-wing home__bird-wing--left"
      d="M12 6.4 C9.4 3.4 5.6 1.4 0.8 1.8 C4.6 3.6 8 5.4 12 6.4Z"
    />
    <path
      className="home__bird-wing home__bird-wing--right"
      d="M12 6.4 C14.6 3.4 18.4 1.4 23.2 1.8 C19.4 3.6 16 5.4 12 6.4Z"
    />
  </svg>
);

/**
 * A few birds receding into the mural — slow, continuous loop.
 */
const HomeBirds = () => (
  <div className="home__birds" aria-hidden="true">
    {BIRDS.map((bird) => (
      <span
        key={bird.id}
        className={`home__bird home__bird--${bird.id}`}
        style={{
          '--bird-x0': bird.x0,
          '--bird-y0': bird.y0,
          '--bird-xv': bird.xv,
          '--bird-yv': bird.yv,
          '--bird-size': `${bird.size}px`,
          '--bird-duration': `${bird.duration}s`,
          '--bird-delay': `${bird.delay}s`,
          '--bird-flap': `${bird.flap}s`,
        }}
      >
        <span className="home__bird-shape">
          <BirdGlyph />
        </span>
      </span>
    ))}
  </div>
);

export default HomeBirds;
